import React from "react";
import { Link } from 'react-router-dom';

function ItemCards(props)
{
  return(
    <>
    <Link style={{ textDecoration: 'none', color: 'inherit' }} to = {{pathname:'/item', 
        state:{ itemSeller:props.seller, itemID:props.itemID, itemRating:props.rating }}}>
        <div className="card" style={{width: "18rem"}}>
            <img src={props.images} className="card-img-top" alt="..."  style={{width: '100%', height: '15vw', objectFit: 'cover'}}/>
            <div className="card-body w3-light-gray">
                <p className="card-title" style={{  lineHeight: '1.5em', height: '3em', overflow: 'hidden', fontSize:'13px'}}>{props.title}</p>
                <h3 className="card-text" style={{textAlign:'justify',color:'orange'}}>RS. {props.price}</h3>
                <p style={{fontSize:'12px'}}> 
                {props.rating.rating__avg !== null ?[ ...Array(5)].map((star, i) => {
                        const ratingValue = i+1;
                        const val= (props.rating - ratingValue)+1;
                        return(
                            <>
                            <label>
                            {(val > 0 && val<1) ? 
                                <i className='fa fa-star-half-full' style={{color:'#ffc107'}} />
                            :
                                <i className='fa fa-star' 
                                style={{ color:ratingValue <= ( props.rating ) ? '#ffc107' : '#D3D3D3'}} />
                            }
                            </label>
                            </>
                        );
                    }):'Not rated'}
                    </p>
            </div>
        </div>
    </Link>
    </>
    )
}
export default ItemCards;